import {
  Component, Input, Output, EventEmitter,
  OnInit, OnChanges, SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { EntityService } from 'src/app/services/entity.service'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UsersService } from 'src/app/services/users.service';
import { EditEntityLogoComponent } from '../edit-entity-logo/edit-entity-logo.component';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: [ './general.component.scss' ],
})
export class GeneralComponent implements OnInit, OnChanges {
  @Input() defaults: any;
  @Input() error: any;
  @Input() entity: any;
  @Output() setNewDefaults = new EventEmitter<object>();
  @Output() refreshUser = new EventEmitter<any>();

  $entity: any;

  primaryEmail = '';
  primaryContact = '';
  primaryBuildingName = '';
  fileTypeInS3 = 'ENTITY_LOGO';
  logoSrc: SafeUrl | null = null;
  noUploadDropzone = true;
  loggedInSubscription: Subscription;
  reloadLogoSub: Subscription;
  user$: Observable<any>;
  entity$: Observable<any>;
  localTimezone = '';
  private subs: Subscription = new Subscription();

  constructor(
    private authService: AuthService, private entityService: EntityService, private sanitizer: DomSanitizer, private usersService: UsersService, public dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    this.authService.entity$.subscribe((entity) => {
      this.$entity = entity;

      if (this.$entity) {
        this.primaryContact = this.$entity?.primaryContact;
        this.primaryEmail = this.$entity?.primaryEmail;
        this.primaryBuildingName = this.$entity?.Config?.PrimaryBuilding?.buildingName;
      }
    });

    this.user$ = this.authService.user$
    this.entity$ = this.authService.entity$
    this.reloadLogoSub = this.usersService.reloadLogo$.subscribe(() => this.loadEntityLogo());

    this.subs.add(this.authService.entity$.subscribe((entity) => {
      if (entity) {
        this.loadEntityLogo();
      }
    }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    // When entity or defaults inputs change, re-initialize
    if (changes['entity'] || changes['defaults']) {
      this.initializeFromInputs();
    }
  }

  initializeFromInputs(): void {
    const sourceEntity = this.entity || this.defaults;

    if (sourceEntity) {
      // Account owner resolution lives in EntityService only; component just consumes it.
      const owner = this.entityService.getAccountOwner(sourceEntity);
      this.primaryContact = owner?.fullName ?? '';
      this.primaryEmail = owner?.email ?? '';
      this.primaryBuildingName = sourceEntity?.Config?.PrimaryBuilding?.buildingName ?? '';
      this.localTimezone = sourceEntity?.Config?.localTimezone ?? sourceEntity?.localTimezone ?? '';
    }
  }

  loadEntityLogo(): void {
    this.authService.user$.subscribe(user => {
      if (user && user.loginName) {
        this.entityService.getEntityLogo(user.loginName).subscribe({
          next: (response: any) => {
            if (response && response.data && response.data.logoUrl) {
              this.logoSrc = response.data.logoUrl;
            }
          },
          error: (error) => {
            console.error('Failed to load entity logo:', error);
          },
        });
      }
    }).unsubscribe();
  }

  onImageFileSelected(blobUrl: any) {
    this.logoSrc = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getBuildingId = (buildingName: string) => {
    const foundBuilding = this.entity?.Buildings?.find((b: any) => b.buildingName === buildingName);
    return Number(foundBuilding?.id);
  }

  updateDefaults = (event: any, key: any) => {
    let value = event.target.value;

    if (key === 'primaryBuildingId') {
      value = this.getBuildingId(value);
    }

    if (key === 'primaryContact') {
      this.primaryContact = value;

      const email = this.populateEmail(value);
      if (email) {
        this.primaryEmail = email;
        this.setNewDefaults.emit({ primaryEmail: email });
      }
    }

    if (key === 'primaryEmail') {
      this.primaryEmail = value;
    }

    const newDefaults = { [key]: value };
    this.setNewDefaults.emit(newDefaults);
  }

  populateEmail = (contactName: string): string | null => {
    if (contactName === '') return null;
    const foundUser = this.entity?.Users?.find((u: any) => u.fullName === contactName);

    if (!foundUser) return null;

    const email = foundUser?.contactEmail || foundUser.loginName;
    return email || null;
  }

  openChangeEntityLogoModal = () => {
    const dialogRef = this.dialog.open(EditEntityLogoComponent)

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.refreshUser.emit(result);
      }
    });
  }

}
